import React from "react";
import "./Header.css";
import CTA from "./CallToAction";
import ME from '../../Assets/Images/C_bg-less-smaller.png';
import HeaderSocials from "./HeaderSocials";

export default class Header extends React.Component {
    render() {
        return (
        <header className="header" id='#'>
             {/* this type of of naming classes is called BEM naming convention */}
        <div className="container header_container">

            <h5>Hello There!!</h5>
            <h1>I am Munyaradzi (Munya)</h1>
            <h5 className="text-light">Junior Fullstack Developer</h5>
            <CTA />
            <HeaderSocials />

            {/* Add the imaage*/}
            <div className="me">
                <img src={ME} alt="" />
            </div>
            <a href='#contact' className='scroll_down'> Scroll down </a>
        </div>
        </header>
        );
    }
    }